export const GET_PROFILE = 'profile/GET_PROFILE';
export const PUT_UPDATE_PROFILE = 'profile/PUT_UPDATE_PROFILE';
export const PUT_UPDATE_PASSWORD = 'profile/PUT_UPDATE_PASSWORD';

export const GET_PROFILE_COMPANIES = 'profile/GET_PROFILE_COMPANIES';
export const GET_PROFILE_COMPANY = 'profile/GET_PROFILE_COMPANY';
export const POST_PROFILE_COMPANY = 'profile/POST_PROFILE_COMPANY';
export const PUT_PROFILE_COMPANY = 'profile/PUT_PROFILE_COMPANY';
export const DELETE_PROFILE_COMPANY = 'profile/DELETE_PROFILE_COMPANY';
export const PUT_PROFILE_COMPANY_STATE = 'profile/PUT_PROFILE_COMPANY_STATE';
export const CLEAR_PROFILE_COMPANY = 'profile/CLEAR_PROFILE_COMPANY';

export const GET_PROFILE_COMPANY_BIKES = 'profile/GET_PROFILE_COMPANY_BIKES';
export const POST_PROFILE_COMPANY_BIKE = 'profile/POST_PROFILE_COMPANY_BIKE';
export const PUT_PROFILE_COMPANY_BIKE = 'profile/PUT_PROFILE_COMPANY_BIKE';
export const DELETE_PROFILE_COMPANY_BIKE = 'profile/DELETE_PROFILE_COMPANY_BIKE';

export const POST_PROFILE_COMPANY_BIKE_PHOTO = 'profile/POST_PROFILE_COMPANY_BIKE_PHOTO';
export const DELETE_PROFILE_COMPANY_BIKE_PHOTO = 'profile/DELETE_PROFILE_COMPANY_BIKE_PHOTO';

export const GET_PROFILE_COMPANY_EXTRAS = 'profile/GET_PROFILE_COMPANY_EXTRAS';
export const POST_PROFILE_COMPANY_EXTRA = 'profile/POST_PROFILE_COMPANY_EXTRA';
export const PUT_PROFILE_COMPANY_EXTRA = 'profile/PUT_PROFILE_COMPANY_EXTRA';
export const DELETE_PROFILE_COMPANY_EXTRA = 'profile/DELETE_PROFILE_COMPANY_EXTRA';

export const GET_PROFILE_COMPANY_LEAVE_LOCATIONS = 'profile/GET_PROFILE_COMPANY_LEAVE_LOCATIONS';
export const POST_PROFILE_COMPANY_LEAVE_LOCATION = 'profile/POST_PROFILE_COMPANY_LEAVE_LOCATION';
export const PUT_PROFILE_COMPANY_LEAVE_LOCATION = 'profile/PUT_PROFILE_COMPANY_LEAVE_LOCATION';
export const DELETE_PROFILE_COMPANY_LEAVE_LOCATION = 'profile/DELETE_PROFILE_COMPANY_LEAVE_LOCATION';

export const GET_PROFILE_COMPANY_BOOKINGS = 'profile/GET_PROFILE_COMPANY_BOOKINGS';

export const GET_PROFILE_COMPANY_RESERVATIONS = 'profile/GET_PROFILE_COMPANY_RESERVATIONS';
export const POST_PROFILE_COMPANY_RESERVATION = 'profile/POST_PROFILE_COMPANY_RESERVATION';
export const PUT_PROFILE_COMPANY_RESERVATION = 'profile/PUT_PROFILE_COMPANY_RESERVATION';
export const DELETE_PROFILE_COMPANY_RESERVATION = 'profile/DELETE_PROFILE_COMPANY_RESERVATION';

export const GET_PROFILE_COMPANY_SEASONS = 'profile/GET_PROFILE_COMPANY_SEASONS';
export const POST_PROFILE_COMPANY_SEASON = 'profile/POST_PROFILE_COMPANY_SEASON';
export const PUT_PROFILE_COMPANY_SEASON = 'profile/PUT_PROFILE_COMPANY_SEASON';
export const DELETE_PROFILE_COMPANY_SEASON = 'profile/DELETE_PROFILE_COMPANY_SEASON';

export const GET_PROFILE_COMPANY_TARIFFS = 'profile/GET_PROFILE_COMPANY_TARIFFS';
export const POST_PROFILE_COMPANY_TARIFF = 'profile/POST_PROFILE_COMPANY_TARIFF';
export const PUT_PROFILE_COMPANY_TARIFF = 'profile/PUT_PROFILE_COMPANY_TARIFF';
export const DELETE_PROFILE_COMPANY_TARIFF = 'profile/DELETE_PROFILE_COMPANY_TARIFF';
export const GET_PROFILE_COMPANY_TARIFFS_SOURCE = 'profile/GET_PROFILE_COMPANY_TARIFFS_SOURCE';
export const POST_PROFILE_BULK_COMPANY_TARIFF = 'profile/POST_PROFILE_BULK_COMPANY_TARIFF';

export const GET_PROFILE_BOOKINGS = 'profile/GET_PROFILE_BOOKINGS';

export const GET_PROFILE_COMPANY_TIMELINE_BOOKINGS = 'profile/GET_PROFILE_COMPANY_TIMELINE_BOOKINGS';
export const POST_PROFILE_COMPANY_TIMELINE_BOOKING = 'profile/POST_PROFILE_COMPANY_TIMELINE_BOOKING';
export const PUT_PROFILE_COMPANY_TIMELINE_BOOKING = 'profile/PUT_PROFILE_COMPANY_TIMELINE_BOOKING';
export const DELETE_PROFILE_COMPANY_TIMELINE_BOOKING = 'profile/DELETE_PROFILE_COMPANY_TIMELINE_BOOKING';

export const POST_PROFILE_COMPANY_MEDIA = 'profile/POST_PROFILE_COMPANY_MEDIA';

// Site integrations
export const PROFILE_INTEGRATIONS_SET_BUTTON = 'profile/integrations/SET_BUTTON';



// WEBPACK FOOTER //
// ./src/constants/profile.js